import { DialogTitle, Divider, GridProps, useTheme } from '@mui/material';
import { ContextForm, IFormAfterSubmit, InputOnlyField, Select, Suggestion } from '@ngt/forms';
import { ValidateOn } from '@ngt/forms-core';
import { FC, useCallback, useContext } from 'react';
import { UserAgentLocation } from '../../api/dtos';
import UserAgentLocationSummariesContext from '../../contexts/UserAgentLocationsContext';
import { IFormDialogProps, StyledButton, StyledDialog, StyledDialogActions, StyledDialogContent, StyledFormColumn, StyledFormSubmitButton } from '../inputs/CommonFormElements';

const COLUMN_SIZING: GridProps['size'] = {
    xs: 12,
    sm: 12,
    md: 6,
    lg: 6,
    xl: 6
} 

const AgentPersonnelForm: FC<IFormDialogProps> = (props) => {
    const theme = useTheme();
    const { refresh: refreshAgentLocations } = useContext(UserAgentLocationSummariesContext);
    

    const onAfterSubmit: IFormAfterSubmit<UserAgentLocation> = useCallback(async (_newValue, _formState, _formActions) => {
        await refreshAgentLocations();
        props.onClose();
    }, [refreshAgentLocations, props.onClose])

    return (
        <StyledDialog {...props}>
            <ContextForm
                onAfterSubmit={onAfterSubmit}
                validateOn={ValidateOn.onChange}
                validateOnReset
                debug
                debugLocation='window'
            >
                <DialogTitle
                    sx={{
                        backgroundColor: theme.palette.secondary.light,
                        color: "white"
                    }}
                >
                    {props.edit ? "Edit" : "Add"} Agent Personnel
                </DialogTitle>
                <StyledDialogContent>
                    <StyledFormColumn
                        size={COLUMN_SIZING}
                    >
                        <InputOnlyField 
                            label="Agent"
                            component={Select}
                            propertyPath={'agentLocationId'}
                            MenuProps={{
                                sx: {
                                    maxHeight: 500
                                }
                            }}
                        />
                        <InputOnlyField 
                            label="Personnel"
                            component={Suggestion}
                            propertyPath={'username'}
                            freeSolo
                        />
                    </StyledFormColumn>
                </StyledDialogContent>
                <Divider />
                <StyledDialogActions>
                    <StyledFormSubmitButton variant="contained">Submit</StyledFormSubmitButton>
                    <StyledButton variant="contained" onClick={props.onClose}>Cancel</StyledButton>
                </StyledDialogActions>
            </ContextForm>
        </StyledDialog>
    );
}

export default AgentPersonnelForm;